import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

export const GridItem = styled.li.withConfig({ componentId: 'sc-q5d4fx-0' })`
    flex: 1 0 auto;
    width: 100%;
    max-width: 100%;
`;

export interface IGrid {
  $columns?: number;
  $columnsSm?: number;
  $columnsMd?: number;
  $spacing?: number;
}

export const Grid = styled.ul.withConfig({ componentId: 'sc-q5d4fx-1' })<IGrid>`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    list-style: none;
    padding: 0;
    margin: 0;

    ${({ $spacing }) =>
      $spacing &&
      css`
            margin: -${size($spacing / 2)};

            ${GridItem} {
                padding: ${size($spacing / 2)};
            }
        `}

    ${({ $columns }) =>
      $columns &&
      css`
            ${GridItem} {
                width: ${100 / $columns}%;
                max-width: ${100 / $columns}%;
            }
        `}

  ${({ $columnsSm }) =>
    $columnsSm &&
    css`
            ${(props) => props.theme.breakpoint.Sm} {
                ${GridItem} {
                    width: ${100 / $columnsSm}%;
                    max-width: ${100 / $columnsSm}%;
                }
            }
        `}

  ${({ $columnsMd }) =>
    $columnsMd &&
    css`
            ${(props) => props.theme.breakpoint.Md} {
                ${GridItem} {
                    width: ${100 / $columnsMd}%;
                    max-width: ${100 / $columnsMd}%;
                }
            }
        `}
`;
